var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"mr-3",staticStyle:{"width":"70px !important"},attrs:{"src":"/dda_logo.png","alt":"Logo DDA"}})}
var staticRenderFns = []

export { render, staticRenderFns }